// src/utils/colorUtils.js
const generateMutedColor = (index) => {
  const colors = [
    '#C1D5A5',
    '#b39b94',
    '#85c9ea',
    '#e6e6a5',
    '#A8D5BA',
    '#9ed7dd',
    '#FFAAA5',
    '#9DBAD5',
    '#FFCAD4',
    '#C1D5A5',
    '#FFE5A5',
    '#8c99aa',
    '#51564f',
  ];
  return colors[index % colors.length];
};

export default generateMutedColor;

export const getStatusColor = (status) => {
  switch (status) {
    case 'created':
      return '#027A4B';
    case 'draft':
      return '#545454';
    case 'active':
      return '#027A48';
    case 'inactive':
      return '#842318';
    case 'archived':
      return '#FF4B4B';
    default:
      return '#FF4B4B';
  }
};

export const getStudyTypeColor = (type) => {
  switch (type?.toLowerCase()) {
    case 'interview':
      return '#175CD3';
    case 'survey':
      return '#027A4B';
  }
};

export const getUserAccessType = (type) => {
  switch (type) {
    case 'Owner':
      return {
        label: 'Owner',
        color: '#7b1fa2',
        backgroundColor: '#f3e5f5',
      };
    case 'Admin':
      return {
        label: 'Admin',
        color: '#2196f3',
        backgroundColor: '#e3f2fd',
      };
    case 'Viewer':
      return {
        label: 'Viewer',
        color: '#ff4b4b',
        backgroundColor: '#fce4ec',
      };
    case 'Editor':
      return {
        label: 'Editor',
        color: '#ff9800',
        backgroundColor: '#fff3e0',
      };
  }
};
